import { v4 as uuidv4 } from 'uuid';

//This session id is used to identify the user and keep track of their session for the websocket connections.
export const SESSION_ID = uuidv4();
